var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrizeCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.214081,
    width: 16,
    height: 16.0669,
    rx: 2,
    fill: "#F9AE38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.22664V13.2685",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.13864C11 4.13864 8.49265 4.13864 7.25 4.13864C6.00735 4.13864 5 5.05825 5 6.19265C5 7.32706 6.00735 8.24667 7.25 8.24667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.3552C5.5 12.3552 8.00735 12.3552 9.25 12.3552C10.4927 12.3552 11.5 11.4356 11.5 10.3012C11.5 9.16675 10.4927 8.24715 9.25 8.24715H7.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeCash);
export default __webpack_public_path__ + "static/media/prize-cash.eebf3141771128971b1dc4b565acb2ab.svg";
export { ForwardRef as ReactComponent };